module.exports = __webpack_public_path__ + "img/pink-clouds-calling.448fd548.jpg";